import React from 'react';
import {Field} from 'formik';
import {FormControl, FormHelperText, MenuItem, Select, TextField} from "@mui/material";
import {Eyebrow, FieldLabel, SwitchCard, UI, cardBaseSx} from "./FormUiKit.js";

/**
 * Carte « Formulaire » (refonte handoff FormNewOrEdit v2) : identité du form
 * (libellé + client) et options transverses (galerie, relevé terrain).
 * La config du lavage (typologie, photos, lavage partiel) vit dans ActeLavageCard.
 *
 * Options QRCode / Code Barre / RFID / Volume / Type de déchet : retirées du
 * produit (handoff) — plus d'UI, mais les valeurs restent envoyées à l'API
 * (colonnes NOT NULL + app Android qui les lit encore).
 */
function FormDataField({clients, values, errors, touched, handleChange, handleBlur}) {
    return (
        <div style={{...cardBaseSx(false), padding: "22px 24px"}}>
            <Eyebrow style={{marginBottom: 16}}>Formulaire</Eyebrow>

            <div style={{display: "flex", gap: 16, flexWrap: "wrap"}}>
                <div style={{flex: 1, minWidth: 220}}>
                    <FieldLabel required>Libellé</FieldLabel>
                    <Field type="text" name="libelle">
                        {({form}) => (
                            <TextField
                                fullWidth
                                size="small"
                                name="libelle"
                                value={values.libelle}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={Boolean(form.errors.libelle && form.touched.libelle)}
                                helperText={form.errors.libelle && form.touched.libelle && String(form.errors.libelle)}
                                sx={{
                                    "& .MuiOutlinedInput-root": {borderRadius: "10px"},
                                    "& fieldset": {borderColor: UI.fieldBorder},
                                }}
                            />
                        )}
                    </Field>
                </div>

                <div style={{flex: 1, minWidth: 220}}>
                    <FieldLabel required>Client à rattacher</FieldLabel>
                    <Field type="text" name="client">
                        {({form}) => (
                            <FormControl fullWidth size="small" error={Boolean(errors.client)}>
                                <Select
                                    name="client"
                                    value={values.client || ''}
                                    onChange={handleChange}
                                    displayEmpty
                                    sx={{
                                        borderRadius: "10px",
                                        "& fieldset": {borderColor: UI.fieldBorder},
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        <span style={{color: UI.textMuted}}>Sélectionner le client…</span>
                                    </MenuItem>
                                    {clients && clients.map((e) => (
                                        <MenuItem key={e.id} value={e["@id"]}>{e.libelle}</MenuItem>
                                    ))}
                                </Select>
                                {form.errors.client && form.touched.client && (
                                    <FormHelperText error>{String(form.errors.client)}</FormHelperText>
                                )}
                            </FormControl>
                        )}
                    </Field>
                </div>
            </div>

            <div style={{display: "flex", gap: 12, marginTop: 18, flexWrap: "wrap"}}>
                <Field name="galleryEnabled">
                    {({form}) => (
                        <SwitchCard
                            checked={Boolean(values.galleryEnabled)}
                            onToggle={(v) => form.setFieldValue('galleryEnabled', v)}
                            title="Galerie photos"
                            subtitle="L'opérateur peut choisir une photo existante"
                        />
                    )}
                </Field>
                <Field name="releveTerrainEnabled">
                    {({form}) => (
                        <SwitchCard
                            checked={Boolean(values.releveTerrainEnabled)}
                            onToggle={(v) => form.setFieldValue('releveTerrainEnabled', v)}
                            title="Relevé terrain"
                            subtitle="Saisie d'informations patrimoine sur place"
                        />
                    )}
                </Field>

	            <Field name="photoGpsStampEnabled">
		            {({form}) => (
		              <SwitchCard
			            checked={Boolean(values.photoGpsStampEnabled)}
			            onToggle={(v) => form.setFieldValue('photoGpsStampEnabled', v)}
			            title="Incrustation GPS"
			            subtitle="Coordonnées GPS incrustées sur les photos"
		              />
		            )}
	            </Field>
                <Field name="commentaireEnabled">
                    {({form}) => (
                        <SwitchCard
                            checked={Boolean(values.commentaireEnabled)}
                            onToggle={(v) => form.setFieldValue('commentaireEnabled', v)}
                            title="Commentaire"
                            subtitle="L'opérateur peut laisser un commentaire sur l'intervention"
                        />
                    )}
                </Field>
            </div>
        </div>
    );
}

export default FormDataField;
